import PropTypes from 'prop-types';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';

import './Facilities.scss';

const Facilities = ({ title = '', content = '' }) => {
  return (
    <div className="facilities">
      <SectionHeading text={title} level={3} />

      <ul className="facilities__content">
        <li>{content}</li>
      </ul>
    </div>
  );
};

Facilities.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string
};

export default Facilities;
